import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import Carousel from "./components/Carousel";
import PackageCarouselTopper from "./components/PackageCarouselTopper";
import CtaSection from "./components/CtaSection";
import { PackageCarouselProps } from "./package-carousel.props";
import Cards from "./components/Cards";
import ComparePackagesTray, { ComparePkgTrayProvider } from "../ComparePackageTray";

const styles = {
  rootContainerStyles: {
    pt: {
      xs: "48px",
      sm: "72px",
      md: "72px"
    },
    pb: {
      xs: "24px",
      sm: "32px"
    },
    display: "flex",
    flexDirection: "column"
  },
  ctaContainerStyles: {
    display: {
      xs: "flex",
      sm: "none"
    },
    flexDirection: "column",
    gap: "14px",
    p: "20px 0",
    m: {
      xs: "24px 20px 0 20px",
      sm: "0 0 0 0",
      md: "0 0 0 0"
    }
  }
};
const PackageCarouselContent = (props: PackageCarouselProps) => {
  const {
    background,
    cards,
    title,
    subHeading,
    bodyText,
    priceText,
    cta,
    secondaryCta,
    myFreeConfig,
    controlsConfig,
    config,
    comparePkgTray
  } = props;
  try {
    return (
      <DtvBox sx={{ background }}>
        <DtvBox
          data-testid="package-carousel-root-container"
          id={"package-carousel-root-container"}
          sx={{ ...styles.rootContainerStyles }}
        >
          <PackageCarouselTopper
            bodyText={bodyText}
            config={config}
            cta={cta}
            data-testid="package-carousel-topper"
            priceText={priceText}
            secondaryCta={secondaryCta}
            subHeading={subHeading}
            title={title}
          />
          {config?.isAutoScrollNeeded ? (
            <Carousel
              cards={cards}
              carouselSpeed={config?.scrollSpeed || 1}
              config={config}
              controlsConfig={controlsConfig}
              data-testid="package-carousel-carousel"
              myFreeConfig={myFreeConfig}
            />
          ) : (
            <Cards
              cards={cards}
              config={config}
              controlsConfig={controlsConfig}
              data-testid="package-carousel-cards"
              myFreeConfig={myFreeConfig}
            />
          )}
          {config?.isCtaPositionBottom && (cta || secondaryCta) && (
            <DtvBox
              data-testid="package-carousel-mobile-cta-container"
              id={"package-carousel-mobile-cta-container"}
              sx={{ ...styles.ctaContainerStyles }}
            >
              <CtaSection cta={cta} data-testid="package-carousel-cta-section" secondaryCta={secondaryCta} />
            </DtvBox>
          )}
        </DtvBox>
        <ComparePackagesTray {...comparePkgTray} originType="packageCarousel" />
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="Dtv Card" error={error} />;
  }
}
const PackageCarousel = (props: PackageCarouselProps) => (
    <ComparePkgTrayProvider
      compareText={props?.comparePkgTray?.compareText}
      isComparePkgTray={props?.comparePkgTray?.isCompareEnabled}
      maxSelectedTag={Number(props?.comparePkgTray?.maxSelectedPackages) || 3}>
      <PackageCarouselContent {...props} />
    </ComparePkgTrayProvider>
);

export default React.memo(PackageCarousel);
